import Bottom from "./Bottom";
import Content from "./Content";
import Preview from "./Preview";
import React, { useEffect } from "react";
import { Wrapper } from '../ActionModal';
import { useSelector, useDispatch } from "react-redux";
import useViewerStore from '../../store-zustand/viewer';
import useProjectStore from '../../store-zustand/project';
import { MapModalAnnotateStatus, AnnotationTypes } from "constant";

const MapModal = (props) => {
  const { type, info, status, onChangeStatus, onChangeDimension, onAddAsset, onclose, disabled } = props;
  const { setmapboxvisibility } = useViewerStore();
  const showMapModal = useSelector(state => state.settings.showMapModal);
  const showMeasurementModal = useSelector(state => state.settings.showMeasurementModal);
  const showExportModal = useSelector(state => state.settings.showExportModal);
  const showPrintModal = useSelector(state => state.settings.showPrintModal);
  const showTaskingModal = useSelector(state => state.settings.showTaskingModal);
  const { currentAnnotationName, currentAnnotationDescription, uploadImage, updateannotationStyle, setcurrentAnnotationId, currentImageToUploadAnnotation, setsingleannotationeidtion, setreloadAnnotationsList } = useProjectStore();
  const dispatch = useDispatch();

  const handleClickAction = (title) => {
    if (title === "Add Site Data" && type === "CurrentProject") {
      onAddAsset();
    } else if (AnnotationTypes[type]) {
      let nextStatus = "";
      if (!status || !status.length || status === MapModalAnnotateStatus.Success) nextStatus = MapModalAnnotateStatus.Edit;
      if (status === MapModalAnnotateStatus.Edit) nextStatus = "";
      onChangeStatus(nextStatus);
    } else {
      onChangeStatus();
    }
  };

  const handleSubmit = async (annotationIndex) => {
    setsingleannotationeidtion(undefined);
    if (status === MapModalAnnotateStatus.Edit) {
      onChangeStatus(MapModalAnnotateStatus.Success);
      let copy = Object.assign({}, window.annotationObj[annotationIndex]);
      let keyword = {};
      keyword.annotationID = copy.Idannotation;
      keyword.style = copy;
      keyword.annotationname = currentAnnotationName;
      keyword.annotationdescription = currentAnnotationDescription;
      keyword.style.FillColor = keyword.style.FillColor.toCssHexString();
      keyword.style.PinColor = keyword.style.PinColor.toCssHexString();
      keyword.style.LabelfillColor = keyword.style.LabelfillColor.toCssHexString();
      keyword.style.Polygonoutlinecolor = keyword.style.Polygonoutlinecolor.toCssHexString();
      keyword.style = JSON.stringify(keyword.style);

      let annotationStyle = await updateannotationStyle(keyword);
      if (annotationStyle !== 'error') {
        setreloadAnnotationsList(parseInt(annotationStyle) + Math.floor(Math.random() * 1000) + 1);
      } else {
        alert('Error while updating style');
      }

      if (currentImageToUploadAnnotation !== undefined) {
        let currentImage = currentImageToUploadAnnotation;
        let formData = new FormData();
        formData.append("image", currentImage);
        formData.append("annotationID", keyword.annotationID);
        let UploadedImage = await uploadImage(formData, keyword);
        
        if (UploadedImage === 'error') alert('Erro while uploading image');
      }

      onclose();
    }
  };

  const closeModal = () => {
    dispatch({ type: 'TOGGLE_MAP_MODAL', show: false });
  }

  useEffect(() => {
    if (!showMapModal && !showMeasurementModal && !showExportModal && !showPrintModal && !showTaskingModal) {
      setmapboxvisibility(0);
    } else {
      setmapboxvisibility(1);
    }
  }, [showMapModal, showMeasurementModal, showExportModal, showPrintModal, showTaskingModal])

  return (
    showMapModal ?
      <Wrapper>
        <Preview type={type} closeModal={closeModal} status={status} disabled={disabled} info={info} onAction={handleClickAction} />
        <Content type={type} info={info} onChangeDimension={onChangeDimension} />
        <Bottom type={type} info={info} onChangeDimension={onChangeDimension} status={status} onSubmit={handleSubmit} />
      </Wrapper>
      : null
  );
};

export default MapModal;